import { toFullRoleLabel } from './roleLabels';

type RoleKey = 'PO' | 'DF' | 'MD' | 'DL' | '-';

export interface RoleChipProps {
  role?: string | null;
  variant?: 'short' | 'full';
}

function toRoleKey(role?: string | null): RoleKey {
  const normalized = (role ?? '').trim().toUpperCase();

  switch (normalized) {
    case 'PORTERO':
      return 'PO';
    case 'DEFENSA':
      return 'DF';
    case 'CENTROCAMPISTA':
      return 'MD';
    case 'DELANTERO':
      return 'DL';
    default:
      return '-';
  }
}

const ROLE_CLASSES: Record<RoleKey, string> = {
  PO: 'bg-orange-500 text-white',
  DF: 'bg-purple-500 text-white',
  MD: 'bg-blue-500 text-white',
  DL: 'bg-yellow-400 text-gray-900',
  '-': 'bg-gray-400 text-gray-900',
};

export const RoleChip = ({ role, variant = 'short' }: RoleChipProps) => {
  const roleKey = toRoleKey(role);
  const displayText = variant === 'full' ? toFullRoleLabel(role) : roleKey;

  return (
    <div className={`inline-block m-0 pointer-events-none select-none rounded-md ${ROLE_CLASSES[roleKey]}`}>
      <span className="px-1.5 text-xs leading-none font-bold">
        {displayText}
      </span>
    </div>
  );
};
